import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Image as FluentImage, ImageFit } from '@bingads-webui-react/fabric-control';

import { getFolderIconStyle } from './style';

const FolderIconInternal = ({
  thumbnailImageUrl, isEmptyFolder, classes, folderIconRootClassName,
}) => (
  <div className={classnames(classes.folderIconContainer, folderIconRootClassName)}>
    <div className={classnames('folder-tag', isEmptyFolder ? classes.emptyFolderTag : classes.folderTag)} />
    <div className={classnames('folder-content', isEmptyFolder ? classes.emptyFolderContent : classes.folderContent)} >
      { thumbnailImageUrl && <FluentImage
        imageFit={ImageFit.cover}
        src={thumbnailImageUrl}
        alt="folder icon"
        maximizeFrame
      />}
    </div>
  </div>
);

FolderIconInternal.propTypes = {
  thumbnailImageUrl: PropTypes.string,
  classes: PropTypes.shape({
    folderIconContainer: PropTypes.string,
    folderTag: PropTypes.string,
    folderContent: PropTypes.string,
    emptyFolderTag: PropTypes.string,
    emptyFolderContent: PropTypes.string,
  }).isRequired,
  folderIconRootClassName: PropTypes.string,
  isEmptyFolder: PropTypes.bool,
};

FolderIconInternal.defaultProps = {
  thumbnailImageUrl: undefined,
  folderIconRootClassName: '',
  isEmptyFolder: false,
};

export const FolderIcon = withDefaultStyles(FolderIconInternal, getFolderIconStyle);
